<template>
  <div class="filter-bar">
    <v-text-field
      class="filter-bar__search"
      :placeholder="searchPlaceholder"
      :value="localSearch"
      dense
      outlined
      hide-details
      clearable
      @input="localSearch = $event"
    />
    <v-select
      v-for="filter in filters"
      :key="filter.key"
      class="filter-bar__select"
      :items="filter.options"
      item-text="label"
      item-value="value"
      :label="filter.label"
      :value="values[filter.key]"
      dense
      outlined
      hide-details
      @change="onFilterChange(filter.key, $event)"
    />
    <BaseButton @click="onSubmit">
      Filtrar
    </BaseButton>
  </div>
</template>

<script>
export default {
  name: 'BaseFilterBar',
  props: {
    searchPlaceholder: {
      type: String,
      required: false,
      default: ''
    },
    search: {
      type: String,
      required: false,
      default: ''
    },
    filters: {
      type: Array,
      required: false,
      default: () => []
    },
    values: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data() {
    return {
      localSearch: this.search
    }
  },
  watch: {
    search(value) {
      this.localSearch = value
    }
  },
  methods: {
    onFilterChange(key, value) {
      this.$emit('filter-change', key, value)
    },
    onSubmit() {
      this.$emit('submit', this.localSearch)
    }
  }
}
</script>

<style lang="scss">
.filter-bar {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 14px;

  &__search {
    flex: 1;
    min-width: 200px;
  }

  &__select {
    max-width: 220px;
  }
}
</style>
